import { get, isNil, isMatch } from 'lodash';
import { combineReducers } from 'redux';
import { createReducer as createPagerReducer } from 'rp-react-pagination';
import { createReducer as createDataTableReducer } from '../modules/DataTable';
import { createExpandableRowReducer } from '../reducers/expandableRow';
import { createReducer as createGridDataTableReducer } from '../reducers/gridDataTable';
import { getInitialRefinement } from '../helpers/catalogueUtils';
import {
    CATALOGUE_REFINEMENT_CHANGE,
    CATALOGUE_REFINEMENT_RESET,
    CATALOGUE_DATA_CHANGE,
} from '../actions/catalogue';

const initialRefinementState = getInitialRefinement();

function refinement(state = initialRefinementState, action) {
    switch (action.type) {
        case CATALOGUE_REFINEMENT_CHANGE:
            return isMatch(state, action.payload)
                ? state
                : Object.assign({}, state, action.payload);
        case CATALOGUE_REFINEMENT_RESET:
            return initialRefinementState;
        default:
            return state;
    }
}

const initialTotalItems = get(window, 'initialData.pagination.totalItems') || 0;

const initialDataState = {
    totalLots: initialTotalItems,
    lotsFound: initialTotalItems,
    horseNameOptions: [],
    horseSexOptions: [],
    horseAgeOptions: [],
    sireNameOptions: [],
    damNameOptions: [],
    sireOfDamNameOptions: [],
    sellerNameOptions: [],
    buyerDetailOptions: [],
};

function data(state = initialDataState, action) {
    switch (action.type) {
        case CATALOGUE_DATA_CHANGE:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}

function createRefinementHistoryItems(payload) {
    return Object.keys(payload).map(key => ({
        key,
        value: payload[key]
    }));
}

function refinementHistory(state = [], action) {
    switch (action.type) {
        case CATALOGUE_REFINEMENT_CHANGE: {
            const newItems = createRefinementHistoryItems(action.payload);
            const filteredState = state.filter(
                item => !newItems.find(newItem => (newItem.key === item.key))
            );
            const newNonEmptyItems = newItems.filter(
                newItem => !isNil(newItem.value)
            );
            return [...filteredState, ...newNonEmptyItems];
        }
        case CATALOGUE_REFINEMENT_RESET:
            return [];
        default:
            return state;
    }
}

export default function createCatalogueReducer(stateKey) {
    return combineReducers({
        refinement,
        data,
        dataTable: createDataTableReducer(stateKey, window.initialData || {}),
        gridDataTable: createGridDataTableReducer(stateKey),
        pager: createPagerReducer(stateKey, (window.initialData || {}).pagination),
        expandableRow: createExpandableRowReducer(stateKey),
        refinementHistory,
    });
}



// WEBPACK FOOTER //
// ./src/js/reducers/catalogue.js